import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  CURRENT_USER_FEATURE_KEY,
  CurrentUserState,
  currentUserAdapter
} from './current-user.reducer';

// Lookup the 'CurrentUser' feature state managed by NgRx
export const getCurrentUserState = createFeatureSelector<CurrentUserState>(CURRENT_USER_FEATURE_KEY);

const { selectAll, selectEntities, selectIds, selectTotal } = currentUserAdapter.getSelectors();


export const getCurrentUserId = createSelector(
  getCurrentUserState,
  (state: CurrentUserState) => state.currentUser.id
)

export const getCurrentUser = createSelector(
  getCurrentUserState,
  (state: CurrentUserState) => state.currentUser
)


export const listenForCurrentUserFireStoreError = createSelector(
  getCurrentUserState,
  (state: CurrentUserState) => state.firestoreCurrentUserError
);







